import Vue from 'vue';
import layout from '@/components/shared/layout/layout.vue';
import navbar from '@/components/shared/navbar/navbar.vue';
import appFooter from '@/components/shared/footer/footer.vue';
import sidebar from '@/components/shared/sidebar/sidebar.vue';
import breadcrumb from '@/components/shared/breadcrumb/breadcrumb.vue';
import quickview from '@/components/shared/quickview/quickview.vue';

Vue.component('layout', layout);
Vue.component('navbar', navbar);
Vue.component('appFooter', appFooter);
Vue.component('sidebar', sidebar);
Vue.component('breadcrumb', breadcrumb);
Vue.component('quickview', quickview);

//base components
import baseTable from '@/components/base/baseTable/baseTable.vue';
import baseSelect from '@/components/base/baseSelect/baseSelect.vue';
import baseTreeselect from '@/components/base/baseTreeSelect/baseTreeSelect.vue';
Vue.component('baseTable', baseTable);
Vue.component('baseSelect', baseSelect);
Vue.component('baseTreeSelect', baseTreeselect);

//App components
import tramiteBeneficiarioNovedades from '@/components/tramite/tramite-novedad-table.vue';
import direccion from '@/components/direccion/direccion.vue';
import direccionCollapse from '@/components/direccion/collapse.vue';
import direccionMapa from '@/components/direccion/mapa.vue';
import ciudadanoBuscador from '@/components/ciudadano/buscador.vue';
import ciudadanoCarta from '@/components/ciudadano/carta.vue';
import ciudadanoCollapse from '@/components/ciudadano/collapse.vue';
import ciudadanoLink from '@/components/ciudadano/link.vue';
import ciudadanoPhoto from '@/components/ciudadano/photo.vue';
import usuarioLink from '@/components/usuario/link.vue';
import usuarioCarta from '@/components/usuario/carta.vue';
import usuarioCollapse from '@/components/usuario/collapse.vue';
import ciudadanoPerfil from '@/components/ciudadano/perfil.vue';
import ciudadanoPerfilSidebar from "@/components/ciudadano/perfil-sidebar.vue";
import ciudadanoPerfilDetalle from "@/components/ciudadano/perfil-detalle.vue";
import selectProfileSectionAttribute from '@/components/select-profile-section-attribute/select-profile-section-attribute.vue';
import miembroTable from '@/components/miembro/table.vue';
import miembroAdd from '@/components/miembro/add.vue';
import miembroEdit from '@/components/miembro/edit.vue';
import personaDireccionTable from '@/components/persona/direccion/table.vue';
import cuentasTable from '@/components/cuentas/table.vue';

import tramiteBeneficiarioResumen from '@/modules/tramite/resumen.vue';
import tramiteBeneficiarioDocumentos from '@/components/tramite/tramite-beneficiario-documento.vue';
import tramiteBeneficiarioDocumentosResumen from '@/components/tramite/tramite-beneficiario-documento-resumen.vue';

import beneficiarioBuscador from '@/components/beneficiario/buscador.vue';
import documentoTable from '@/components/documento/table.vue';
import tramiteTable from '@/components/tramite/table.vue';
import tramiteDocumentos from '@/components/tramite/documento.vue';
import tramiteNameValueDocumentos from '@/components/tramite/namevalue-documento.vue';
import telefonos from '@/components/telefono/telefono.vue';
import correos from '@/components/correo/correo.vue';
import DatePickerComponent from "@/components/base-datePicker/base-date-picker.vue";
import BaseSelectUserComponent from "@/components/base-select-person/base-select-user.vue";

import movimientosTarjetaTable from '@/components/nomita-transaccion/table.vue';
import nominaTable from '@/components/nomita-transaccion/nomina-table.vue';
import transaccionTable from '@/components/nomita-transaccion/transaccion-table.vue';
import nominaDetalle from '@/components/nomita-transaccion/nomina-detalle.vue';
import transaccionDetalle from '@/components/nomita-transaccion/transaccion-detalle.vue';
import Comentarios from '@/components/comentarios/comentarios.vue';

Vue.component('selectUser', BaseSelectUserComponent);
Vue.component('datePicker', DatePickerComponent);
Vue.component('direccion', direccion);
Vue.component('direccionCollapse', direccionCollapse);
Vue.component('direccionMapa', direccionMapa);
Vue.component('ciudadanoBuscador', ciudadanoBuscador);
Vue.component('ciudadanoCarta', ciudadanoCarta);
Vue.component('ciudadanoCollapse', ciudadanoCollapse);
Vue.component('ciudadanoLink', ciudadanoLink);
Vue.component('ciudadanoPhoto', ciudadanoPhoto);
Vue.component('usuarioLink', usuarioLink);
Vue.component('usuarioCollapse', usuarioCollapse);
Vue.component('ciudadanoPerfil', ciudadanoPerfil);
Vue.component("ciudadanoPerfilSidebar", ciudadanoPerfilSidebar);
Vue.component("ciudadanoPerfilDetalle", ciudadanoPerfilDetalle);
Vue.component('selectProfileSectionAttribute', selectProfileSectionAttribute);
Vue.component('miembroTable', miembroTable);
Vue.component('miembroAdd', miembroAdd);
Vue.component('miembroEdit', miembroEdit);
Vue.component('personaDireccionTable', personaDireccionTable);
Vue.component('beneficiarioBuscador', beneficiarioBuscador);
Vue.component('documentoTable', documentoTable);
Vue.component('tramiteTable', tramiteTable);
Vue.component('tramiteDocumentos', tramiteDocumentos);
Vue.component('tramiteNamevalueDocumentos', tramiteNameValueDocumentos);
Vue.component('telefonos', telefonos);
Vue.component('correos', correos);

Vue.component('tramiteBeneficiarioResumen', tramiteBeneficiarioResumen);
Vue.component('tramiteBeneficiarioDocumentos', tramiteBeneficiarioDocumentos);
Vue.component('tramiteBeneficiarioDocumentosResumen', tramiteBeneficiarioDocumentosResumen);
Vue.component('tramiteBeneficiarioNovedades', tramiteBeneficiarioNovedades);
Vue.component('comentarios', Comentarios);
Vue.component('movimientosTarjetaTable', movimientosTarjetaTable);
Vue.component('nominaDetalle', nominaDetalle);
Vue.component('transaccionDetalle', transaccionDetalle);
Vue.component('cuentasTable', cuentasTable);

Vue.component('usuarioLink', usuarioLink);
Vue.component('usuarioCarta', usuarioCarta);
Vue.component('usuarioCollapse', usuarioCollapse);
//Recursive components
import Profile from '@/modules/Profile/profile.vue';
Vue.component('profile', Profile)

//Hogar alertas
import HogarAlertasTable from '@/components/hogar/alertas-table.vue';
import HogarObservacionesTable from '@/components/hogar/observaciones-table.vue';
import HogarSancionesTable from '@/components/hogar/sanciones-table.vue';
import HogarSuspensionesTable from '@/components/hogar/suspensiones-table.vue';
import NotificationsTable from '@/components/app-notifications/table.vue';
Vue.component('notifications-table', NotificationsTable)
Vue.component('hogar-alertas-table', HogarAlertasTable)
Vue.component('hogar-observaciones-table', HogarObservacionesTable)
Vue.component('hogar-sanciones-table', HogarSancionesTable)
Vue.component('hogar-suspensiones-table', HogarSuspensionesTable)
Vue.component('nominaTable', nominaTable);
Vue.component('transaccionTable', transaccionTable);

//Third party components
//Vue multiselect
import Multiselect from 'vue-multiselect'
import 'vue-multiselect/dist/vue-multiselect.min.css'
Vue.component('multiselect', Multiselect)

//Tree select
import Treeselect from '@riophae/vue-treeselect'
import '@riophae/vue-treeselect/dist/vue-treeselect.css'
Vue.component('treeselect', Treeselect)


//Tipo tramite components
function parseComponentList(value?: string): string[] {
    if (!value)
        return [];

    try {
        return JSON.parse(value);
    } catch (e) {
        console.error("Invalid component list configuration", e);
        return [];
    }
}

const components = parseComponentList(process.env.VUE_APP_LIST_COMPONENTS);
try {
    components.forEach(name => {
        Vue.component(name, require(`@/components/tipo-tramite-components/${name}.vue`).default)
        Vue.component(name + '-resumen', require(`@/components/tipo-tramite-components/${name}-resumen.vue`).default)
    });
} catch (e) {
    console.error(e);
}


//Ciudadano perifl components
const ciudadanoComponents = parseComponentList(process.env.VUE_APP_CIUDADANO_PERFIL_COMPONENTS);
try {
    ciudadanoComponents.forEach(name => Vue.component(name, require(`@/components/ciudadano-perfil-components/${name}.vue`).default));
} catch (e) {
    console.error(e);
}
